<div class="dialog-padding">
  <h1 mat-dialog-title>Fare and Rate Details</h1>
  <div mat-dialog-content>
    <ng-container mat-dialog-content *ngIf="data">
      <table>
        <tr class="header-row">
          <th class="fare-header">Fare & Toll</th>
          <th class="estimated-header">Estimate</th>
          <th class="actual-header">Actual</th>
        </tr>
        <tr>
          <td>Minimum Fare</td>
          <td>{{ data.estimate.minimumFare | currency }}</td>
          <td>{{ data.actual.minimumFare | currency }}</td>
        </tr>
        <tr>
          <td>Distance Rate</td>
          <td>{{ data.estimate.providerDistanceRate | currency }}</td>
          <td>{{ data.actual.providerDistanceRate | currency }}</td>
        </tr>
        <tr>
          <td>Time Rate</td>
          <td>{{ data.estimate.providerTimeRate | currency }}</td>
          <td>{{ data.actual.providerTimeRate | currency }}</td>
        </tr>
        <tr>
          <td>Base Fare</td>
          <td>{{ data.estimate.providerBaseFare | currency }}</td>
          <td>{{ data.actual.providerBaseFare | currency }}</td>
        </tr>
        <tr>
          <td>Distance Fare</td>
          <td>{{ data.estimate.providerDistanceFare | currency }}</td>
          <td>{{ data.actual.providerDistanceFare | currency }}</td>
        </tr>
        <tr>
          <td>Time Fare</td>
          <td>{{ data.estimate.providerTimeFare | currency }}</td>
          <td>{{ data.actual.providerTimeFare | currency }}</td>
        </tr>
      </table>
    </ng-container>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-stroked-button type="button" color="primary" (click)="close()">Close</button>
  </div>
</div>
